import { render, staticRenderFns } from "./ViewThirdPartyServiceComponent.vue?vue&type=template&id=5af0080f&"
import script from "./ViewThirdPartyServiceComponent.vue?vue&type=script&lang=js&"
export * from "./ViewThirdPartyServiceComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports